// extracted by mini-css-extract-plugin
export default {"wrapperDescription":"organization-attributes_wrapperDescription__s7O-T","reduction":"organization-attributes_reduction__6Oquc","value":"organization-attributes_value__sTPyY"};